export default "assets/images/9247459937b9c882303962e42bd8d989.png";